"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostboxErrorCodes = exports.PostBoxActionTypes = void 0;
exports.loadDocuments = loadDocuments;
var _postboxApi = require("../../../../api-factory/postboxApi");
var PostBoxActionTypes = exports.PostBoxActionTypes = /*#__PURE__*/function (PostBoxActionTypes) {
  PostBoxActionTypes["LOAD_DOCUMENTS"] = "api/reducer/LOAD_DOCUMENTS";
  PostBoxActionTypes["LOADING"] = "api/reducer/LOAD_DOCUMENTS/LOADING";
  PostBoxActionTypes["HAS_ERROR"] = "api/reducer/LOAD_DOCUMENTS/HAS_ERROR";
  return PostBoxActionTypes;
}(PostBoxActionTypes || {});
var PostboxErrorCodes = exports.PostboxErrorCodes = /*#__PURE__*/function (PostboxErrorCodes) {
  PostboxErrorCodes["serverError"] = "serverError";
  PostboxErrorCodes["businessPartnerNotFoundInCrm"] = "businessPartnerNotFoundInCrm";
  return PostboxErrorCodes;
}(PostboxErrorCodes || {});
function loadDocuments(dispatch) {
  dispatch({
    type: PostBoxActionTypes.LOADING
  });
  (0, _postboxApi.getPostboxDocuments)().then(function (response) {
    dispatch({
      type: PostBoxActionTypes.LOAD_DOCUMENTS,
      documents: response.data.content
    });
  }).catch(function (error) {
    var errorCode = PostboxErrorCodes.serverError;
    if (error.response.status === 400) {
      var splitError = error.response.data.errors[0].code.split('.');
      if (splitError.includes(PostboxErrorCodes.businessPartnerNotFoundInCrm)) {
        errorCode = PostboxErrorCodes.businessPartnerNotFoundInCrm;
      }
    }
    dispatch({
      type: PostBoxActionTypes.HAS_ERROR,
      errorStatus: error.response.status,
      errorCode: errorCode
    });
  });
}